import React from "react";


export default function LoaderCalendario({ loading }) {
  return (
    <img
      alt=""
      style={{
        width: 50,
        height: 50,
        display: loading ? "block" : "none",
        margin: "auto",
      }}
      src="/loading.gif"
    />
  );
}